import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api, { TOKEN_KEY } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;
    if (!sessionId) {
      navigate("/admin");
      return;
    }
    api.post("/auth/session", { session_id: sessionId })
      .then((r) => {
        if (r.data.session_token) localStorage.setItem(TOKEN_KEY, r.data.session_token);
        setUser(r.data);
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { replace: true });
      })
      .catch(() => navigate("/admin", { replace: true }));
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <div className="w-10 h-10 border-3 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-3" />
        <p className="text-muted-foreground text-sm">Entrando...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
